var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispatcherCallEnded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFCEC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5801 14.7848L17.102 16.7969C17.0422 17.0957 16.8031 17.2949 16.5043 17.2949C11.484 17.275 7.4 13.191 7.4 8.1707C7.4 7.87188 7.5793 7.63281 7.87813 7.57305L9.89023 7.09492C10.1691 7.03516 10.468 7.19453 10.5875 7.45352L11.5238 9.625C11.6234 9.88398 11.5637 10.1828 11.3445 10.3422L10.2688 11.2188C10.9461 12.5934 12.0617 13.709 13.4562 14.3863L14.3328 13.3105C14.4922 13.1113 14.791 13.0316 15.05 13.1313L17.2215 14.0676C17.4805 14.207 17.6398 14.5059 17.5801 14.7848Z",
    fill: "#850000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatcherCallEnded);
export default __webpack_public_path__ + "static/media/DISPATCHER_CALL_ENDED.98e0b98f20389b1db825bfd1f2faf5a6.svg";
export { ForwardRef as ReactComponent };